import isFunction from 'lodash/isFunction'
import merge from 'lodash/merge'

/**
 * Middleware that handles `overrides` key overrides.
 * @type {ThemeMiddleware}
 */
export function muiOverridesMiddleware(baseOverrides, customOverrides) {
  const {
    overrides: baseMuiOverrides = {},
    ...restBaseOverrides
  } = baseOverrides
  const {
    overrides: inputMuiOverrides = {},
    ...restInputOverrides
  } = customOverrides

  // Merge everything except for muiOverrides overrides
  const overrides = merge({}, restBaseOverrides, restInputOverrides)

  // For both standard typography overrides and muiTypography overrides map them
  // with their respective format function and merge base with input.
  const muiOverrides = merge(
    {},
    ...[baseMuiOverrides, inputMuiOverrides].map(muiOverrides =>
      isFunction(muiOverrides) ? muiOverrides(overrides) : muiOverrides
    )
  )

  return {
    ...customOverrides,
    overrides: muiOverrides
  }
}

export default muiOverridesMiddleware
